export default class Tab {
	constructor(element) {
		if (!element) return;
		this.element = element;
		this.events();
	}

	events() {
		this.element.addEventListener('shown.bs.tab', event => {
			const target = event.target.dataset.bsTarget;
			const targetEl = document.querySelector(target);
			const slideshow = targetEl.querySelector('.slideshow');
			let flckt;

			if (slideshow) {
				if ('function' === typeof Flickity) {
					flckt = Flickity.data(slideshow);
					flckt.resize();
				}
			}
		});
	}
}